import classes from "./Loader.module.css"
import React from 'react';

const loader  = (props) =>{
    return(<div className={classes.loader}></div>)
}

export default loader;